import config from "../config.json";
import { target } from "msem-lib/es/lib/target";

export const configuration = () => {
  return config[target()];
};
